<div class="page">
  <div class="header">
    <kgrid
      [apiName]="apiName"
      [areaName]="areaName"
      [label]="label"
      [isAdd]="false"
      [isEdit]="false"
      [name]="apiName"
      pagingSize="10"
      pathPreFix="HRM"
      reportName="HRNotificationHeaderList"
      [groupable]="false"
      defaultSortKey="PersCode"
      defaultSortKeyKind="asc"
      [disableOnDoubleClick]="true"
      (onDoubleClick)="onDoubleClick($event)"
      (onRowSelected)="onDoubleClick($event)"
      [isMulti]="false">
    </kgrid>
  </div>
  <div class="detail">
    <kgrid
      *ngIf="HRNtificationItemColumns && HRNtificationItemColumns.length > 0"
      class="griddetail"
      [label]="label"
      [isAdd]="true"
      [isEdit]="true"
      [isDelete]="true"
      [groupable]="false"
      [noToolBar]="true"
      [name]="HRNtificationItems"
      pathPreFix="Hrm"
      [columns]="HRNtificationItemColumns"
      [dataList]="HRNtificationItems"
      [editFromForm]="true"
      (onEdit)="onEdit($event)"
      (onCreate)="onCreate($event)"
      (onDelete)="onDelete($event)"
      [isMulti]="false">
    </kgrid>
  </div>
</div>
